module.exports = "<p>\r\n  shop-sidebar-category-menu-and-filters works!\r\n</p>\r\n"